// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2lAcG","noInteraction":"EventWrapper_noInteraction__2npkb","pointerPassthrough":"EventWrapper_pointerPassthrough__1ZsIi"};